<template>
  <WelcomeScreens alias="installWelcome" @hidewelcome="redirectToDashboard"/>
</template>

<script>
import WelcomeScreens from "@/components/WelcomeScreens";
import {mapState} from "vuex";

export default {
  name: 'Welcome',
  methods: {
    redirectToDashboard(){
      this.$router.push(this.isPremium ? '/dashboard' : '/freeDashboard')
    }
  },
  computed: {
    ...mapState({
      isPremium: state => state.accountData.isPremium,
    }),
  },
  components: { WelcomeScreens }
}
</script>